export const GLOBAL = {
    MODULE: 'global',
};
export const EVENTS = {
    MODULE_LOADED: 'global.module-loaded',
    SHOW_NOTIFICATION: 'show-notification',
    SHOW_MESSAGE: 'show-message',
    SELECT_FEATURE: 'map.select-feature',
    UNSELECT_FEATURE: 'map.unselect-feature',
    UPDATE_FEATURE: 'map.update-feature',
    INITIALIZE_NEW_FEATURE: 'map.new-feature-initialize',
    FINISHED_NEW_FEATURE: 'map.new-feature-finished',
};